import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { IssueStatusIcon } from "@productlane/ui"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useRoadmapFilterState } from "../roadmap-filter-state"

export const ROADMAP_STATUSES: { value: string; label: string }[] = [
	{ value: "triage", label: "Under review" },
	{ value: "backlog", label: "Backlog" },
	{ value: "unstarted", label: "Todo" },
	{ value: "planned", label: "Planned" },
	{ value: "started", label: "In progress" },
	{ value: "paused", label: "Paused" },
]

export const ROADMAP_STATUS_LABELS: Record<string, string> = Object.fromEntries(
	ROADMAP_STATUSES.map((s) => [s.value, s.label]),
)

export function StatusFilterItems({ onSelect }: SharedFilterItemsProps) {
	const {
		statuses: selectedStatuses,
		addStatus,
		removeStatus,
	} = useRoadmapFilterState()

	return (
		<>
			{ROADMAP_STATUSES.map(({ value, label }) => {
				const isSelected = selectedStatuses.includes(value)
				return (
					<CommandItem
						key={value}
						onSelect={() => {
							if (isSelected) {
								removeStatus(value)
							} else {
								addStatus(value)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<IssueStatusIcon
								status={value}
								className="h-3.5 w-3.5 shrink-0 text-secondary"
							/>
							<span className="flex-1 truncate">{label}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
